<template>
  <PlatformLayout :useOverlay="overlay">
    <v-container fluid>
      <xlsx-read :file="file">
        <xlsx-json @parsed="imported"></xlsx-json>
      </xlsx-read>
      <h2 class="text-center">Importación de destinos</h2>
      <v-row>
        <v-col cols="4" offset="4">
          <v-file-input
            :rules="rules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            placeholder="Selecciona tu archivo excel"
            label="Archivo a importar"
            show-size
            @change="onChange"
          ></v-file-input>
        </v-col>
        <v-col cols="8" class="mx-auto" v-if="destinosImport.length > 0">
          <h3>Destinos a importar</h3>
          <br />
          <v-alert color="blue" type="info">
            El aceptar esta importación implicará borrar definitivamente todos
            los registros actuales de destinos para dar de alta los
            pertenecientes a esta lista.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="destinosImport.length > 0 && errores.length == 0">
        <v-col cols="8" class="mx-auto">
          <v-btn @click="uploadNewDestinies">CARGAR NUEVO CATÁLOGO</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="errores.length > 0">
        <v-col cols="8" class="mx-auto">
          <h3>Errores de formato</h3>
          <br />
          <v-alert color="red" type="error">
            El formato proporcionado presenta los siguientes errores.
            <br />
            <v-list-item class="text-center">
              <v-list-item-content
                v-for="(error, index) of errores"
                :key="index"
              >
                {{ error }}
              </v-list-item-content>
            </v-list-item>
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="destinosImport.length > 0">
        <v-col cols="8" class="mx-auto">
          <v-data-table
            :headers="headers"
            :items="destinosImport"
            :items-per-page="-1"
            class="elevation-3"
            :footer-props="{
              itemsPerPageText: 'El. por página',
              itemsPerPageAllText: 'Todo',
              itemsPerPageOptions: ippoptions,
            }"
            no-data-text="No hay datos para mostrar"
          />
        </v-col>
      </v-row>
    </v-container>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { httpPost } from "@/services/apiService";

export default {
  name: "ImportacionServicio",
  components: {
    PlatformLayout,
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      file: null,
      destinosImport: [],
      rules: [
        (value) =>
          !value ||
          value.size < 20000000 ||
          "El archivo no puede ser mayor que 20 MB.",
      ],
      headers: [
        {
          text: "Estado",
          align: "center",
          sortable: false,
          value: "estado",
        },
        {
          text: "Destino",
          align: "center",
          sortable: false,
          value: "destino",
        },
        {
          text: "Flete",
          align: "center",
          sortable: false,
          value: "valor_flete",
        },
      ],
      ippoptions: [-1],
      errores: [],
      overlay: false,
    };
  },
  methods: {
    onChange(event) {
      this.file = event;
    },
    validateDestinos(lista) {
      let err = [];
      let hasErrors = false;
      for (const l of lista) {
        if (l.valor_flete == null) {
          hasErrors = true;
          err.push(`El flete del destino ${l.estado} ${l.destino} no existe.`);
          return;
        }
        if (typeof l.valor_flete != "number") {
          err.push(
            `El flete del destino ${l.estado} ${l.destino} no es un numero.`
          );
        }
      }

      return {
        hasErrors,
        err,
      };
    },
    async imported(event) {
      this.overlay = true;

      if (this.file == null) {
        this.$toasted.show(
          "No se ha podido detectar formato adecuado en el archivo, revisarlo",
          {
            type: "error",
          }
        );
        return;
      }

      this.destinosImport = [];
      for (const item of event) {
        const data = {
          estado: item["ESTADO"]?.toUpperCase(),
          destino: item["DESTINO"]?.toUpperCase(),
          valor_flete: item["FLETE"] ?? null,
          fletes_techo: {
            una: item["TECHO 1''"],
            una_y_media: item["TECHO 1.5''"],
            dos: item["TECHO 2''"],
            dos_y_media: item["TECHO 2.5''"],
            tres: item["TECHO 3''"],
            cuatro: item["TECHO 4''"],
            cinco: item["TECHO 5''"],
            seis: item["TECHO 6''"],
          },
          fletes_muro: {
            una_y_media: item["MURO 1.5''"],
            dos: item["MURO 2''"],
            dos_y_media: item["MURO 2.5''"],
            tres: item["MURO 3''"],
            cuatro: item["MURO 4''"],
            cinco: item["MURO 5''"],
            seis: item["MURO 6''"],
          },
          transportes_isocindu: {
            torthon: {
              referencia: "TORTHON (7m)",
              valor: item["TORTHON 7m"] ?? null,
            },
            plataformas_40_y_48: {
              referencia: "PLATAFORMAS 40'' Y 48'' (12m Y 14.5m)",
              valor: item["PLATAFORMAS 40 Y 48 PULGADAS"] ?? null,
            },
            plataforma_53: {
              referencia: "PLATAFORMA 53'' (16m)",
              valor: item["PLATAFORMA 53 PULGADAS"] ?? null,
            },
            full_2x40: {
              referencia: "FULL 2x40 (12m)",
              valor: item["FULL 2x40"] ?? null,
            },
          },
        };

        this.destinosImport.push(data);
        this.overlay = false;
      }

      const { hasErrors, err } = this.validateDestinos(this.destinosImport);

      if (hasErrors == true) {
        this.errores = err;
        console.warn("errores de importacion: ", err);
        this.overlay = false;
        return;
      }

      this.overlay = false;
    },
    async uploadNewDestinies() {
      this.overlay = true;
      const { data } = await httpPost("/destinos/bulk-upload", {
        data: { destinies: this.destinosImport },
      }).catch((err) => {
        this.$toasted.show(
          "Ha ocurrido un error, no se puede cargar el formato, hable a soporte",
          {
            type: "error",
          }
        );
        this.overlay = false;
      });

      this.$toasted.show(data?.message, {
        type: "success",
      });

      this.destinosImport = [];
      this.overlay = false;
      this.$router.push({ path: "/platform/destinos" });
    },
  },
};
</script>
